export default "__VITE_ASSET__BUukav9T__"